import { DOCUMENT } from '@angular/common';
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

/**
 * Path base the backend strips for editor requests
 * (`RequestPipelineSetup.StoryblokPreviewPrefix`). The browser URL keeps it.
 * Matched as a whole segment so `/storyblok_previewed` is left alone.
 */
const STORYBLOK_PREVIEW_PREFIX = '/storyblok_preview';

/**
 * Keeps the Storyblok Visual Editor iframe on the story it opened. Sirius links
 * navigate through the router before the bridge's `preventClicks` runs, so the
 * bridge alone cannot stop them.
 *
 * The preview path is on the URL from the first byte. The `storyblok-preview`
 * body class is not, because it is added only after the page has rendered.
 * The first navigation is always allowed so the preview can boot. This is an
 * editor convenience, not an access check — the signed `_storyblok_tk` query
 * is what the backend validates.
 */
export const storyblokPreviewCanActivate: CanActivateFn = () => {
    if (!inject(Router).navigated) {
        return true;
    }

    const pathname = inject(DOCUMENT).defaultView?.location.pathname ?? '';
    return !isStoryblokPreviewPath(pathname);
};

function isStoryblokPreviewPath(pathname: string): boolean {
    const path = pathname.toLowerCase();
    return path === STORYBLOK_PREVIEW_PREFIX || path.startsWith(`${STORYBLOK_PREVIEW_PREFIX}/`);
}
